import locale from "@/helpers/locale";
import moment from "moment";
import momentTimezone from "moment-timezone";

export const createColumn = () => {
  return [
    {
      label: locale("accountPayable.th.name"),
      prop: "name",
      apiProp: "name",
      sort: false,
      width: "220",
    },
    {
      label: locale("accountPayable.th.requestDeadDate"),
      prop: "requestDeadDate",
      apiProp: "requestDeadDate",
      sort: true,
      width: "150",
    },
    {
      label: locale("accountPayable.th.paymentDueDate"),
      prop: "paymentDueDate",
      apiProp: "payDate",
      sort: true,
      width: "150",
    },
    {
      label: locale("accountPayable.th.recordAmount"),
      prop: "recordAmount",
      apiProp: "needPayAmount",
      sort: false,
      align: "right",
      width: "120",
    },
    {
      label: locale("accountPayable.th.amountPaid"),
      prop: "amountPaid",
      apiProp: null,
      sort: false,
      align: "right",
      width: "120",
    },
    {
      label: locale("accountPayable.th.accountPayableBalance"),
      prop: "accountPayableBalance",
      apiProp: null,
      sort: true,
      align: "right",
      width: "120",
    }
  ];
};

export const formatData = (originalArr, typeList) => {
  let newArr = [];
  let notApprove = 0;
  let lastTr = {
    paymentDueDate: locale("accountPayable.trTotal"),
    recordAmount: 0,
    amountPaid: 0,
    accountPayableBalance: 0,
  };

  originalArr.map(item => {
    let obj = {};

    obj.id = item.id;
    obj.approve = item.approve;
    obj.name = item.name;
    obj.requestDeadDate = item.requestDeadDate ? moment(item.requestDeadDate).format("YYYY-MM-DD") : item.requestDeadDate;
    obj.paymentDueDate = item.payDate ? moment(item.payDate).format("YYYY-MM-DD") : item.payDate;
    obj.recordAmount = item.needPayAmount.toLocaleString();
    obj.amountPaid = item.payAmount.toLocaleString();
    obj.accountPayableBalance = item.actualAmountResidual.toLocaleString();
    obj.monthLock = item.monthLock;

    lastTr.recordAmount += item.needPayAmount;
    lastTr.amountPaid += item.payAmount;
    lastTr.accountPayableBalance += item.actualAmountResidual;

    for (let i = 0; i < typeList.length; i++) {
      if (item.type == typeList[i].value) {
        obj.type = typeList[i].label;
        break;
      }
    }

    if (!obj.approve) {
      notApprove += 1;
    }

    newArr.push(obj);
  });

  if (originalArr.length > 0) {
    lastTr.recordAmount = lastTr.recordAmount.toLocaleString();
    lastTr.amountPaid = lastTr.amountPaid.toLocaleString();
    lastTr.accountPayableBalance = lastTr.accountPayableBalance.toLocaleString();

    newArr.push(lastTr);
  }

  return {
    notApprove: notApprove,
    tableData: newArr,
  };
};

export const createOtherPurchaseForm = () => {
  return {
    type: "ELSE_BUY",
    name: "",
    requestDeadDate: 0,
    payDate: 0,
    // billMonthDate: moment().startOf("month").valueOf(),
    needPayAmount: "",
    targetSourceList: {
      elseBuy: [],
    },
  };
};

export const createNullTr = () => ({
  cinemaId: "",
  clientId: "",
  otherGoodsInfoId: "",
  otherGoodsInfo: {
    comment: "",
    price: 0,
    inventory: 0,
    unit: "-",
  },
  priceTotal: 0,
  needPayAmount: 0,
});

export const createOtherPurchaseData = (originAlArr = []) => {
  let newArr = [];
  let lastTr = {
    priceTotal: 0,
    otherGoodsInfo: {
      comment: locale("accountPayable.tableLastTrTotal"),
    },
  };

  if (originAlArr && originAlArr.length > 0) {
    originAlArr.map(item => {
      let priceTotal = item.otherGoodsInfo.price * item.otherGoodsInfo.inventory;
      newArr.push({
        ...item,
        priceTotal: priceTotal,
        otherGoodsInfoId: item.otherGoodsInfo.id,
      });
      lastTr.priceTotal += priceTotal;
    });
  } else {
    newArr.push(createNullTr());
  }

  newArr.push(lastTr);

  return newArr;
};

export const formatOtherPurchaseData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));

  newArr.map(obj => {
    obj.otherGoodsInfo.price = obj.otherGoodsInfo.price == 0 ? "-" : obj.otherGoodsInfo.price;
    obj.otherGoodsInfo.inventory = obj.otherGoodsInfo.inventory == 0 ? "-" : obj.otherGoodsInfo.inventory;
    obj.priceTotal = obj.priceTotal == 0 ? "-" : obj.priceTotal;

    return obj;
  });

  return newArr;
};

export const reverseData = originAlArr => {
  let newArr = JSON.parse(JSON.stringify(originAlArr));

  newArr.map(obj => {
    if (typeof(obj.otherGoodsInfo.price) == "string") {
      obj.otherGoodsInfo.price = parseFloat(obj.otherGoodsInfo.price.replace(/[^\d.-]/g, "")) || 0;
    }

    if (typeof(obj.otherGoodsInfo.inventory) == "string") {
      obj.otherGoodsInfo.inventory = parseFloat(obj.otherGoodsInfo.inventory.replace(/[^\d.-]/g, "")) || 0;
    }

    return obj;
  });

  return newArr;
};

const returnPayableType = str => {
  switch (str) {
  case "TICKETING":
    return "ticketing";

  case "PROXY_BUY":
    return "proxyBuy";

  case "BUY":
    return "buy";

  default:
    return "";
  }
};

export const formatPaymentTableData = (obj, cinemaList, clientList, payDetails = []) => {
  const dataType = obj.type;
  const { targetSourceList } = obj;
  let tableData = [];
  let otherTableData = [];
  let table_last_tr = {
    incomeTotal: 0,
    actualNumberTotal: 0,
    needPayAmount: 0,
    payAmount: 0,
    payMoney: 0,
    adjustment: 0,
    offset: {
      payAmount: 0,
    },
    actualAmountResidual: 0,
  };
  let otherTable_last_tr = {
    needPayAmount: 0,
    payAmount: 0,
    payMoney: 0,
    adjustment: 0,
    offset: {
      payAmount: 0,
    },
    actualAmountResidual: 0,
  };

  let payDetailsIndex = 0;

  if (targetSourceList.source) {
    let keyName = returnPayableType(dataType);
    targetSourceList.source.map(item => {
      let tr = {
        cinemaId: item[keyName].cinemaId,
        clientId: item[keyName].clientId,
        dateInterval: item[keyName].dateInterval,
        needPayAmount: item[keyName].needPayAmount,
        payAmount: item[keyName].payAmount,
        payMoney: 0,
        adjustment: 0,
        offset: {
          payAmount: 0,
        },
        actualAmountResidual: item[keyName].actualAmountResidual,
        uuid: item[keyName].uuid,

        cinemaName: item.cinemaName,
        clientName: item.clientName,
        filmName: item.filmName || "",
        storeName: item.storeName || "",
        incomeTotal: 0,
        actualNumberTotal: 0,
      };

      if (item[keyName].amountDetail && keyName == "ticketing") {
        for (let amountDetailKeyName in item.ticketing.amountDetail) {
          if (amountDetailKeyName !== "total") {
            tr.incomeTotal += item.ticketing.amountDetail[amountDetailKeyName].income;
            tr.actualNumberTotal += item.ticketing.amountDetail[amountDetailKeyName].actualNumber;
          }
        }
      }
      if (payDetails.length > 0) {
        tr = { ...tr, ...payDetails[payDetailsIndex] };
      }

      tableData.push(tr);
      table_last_tr.incomeTotal += tr.incomeTotal;
      table_last_tr.actualNumberTotal += tr.actualNumberTotal;
      table_last_tr.needPayAmount += tr.needPayAmount;
      table_last_tr.payAmount += tr.payAmount;
      table_last_tr.payMoney += tr.payMoney;
      table_last_tr.adjustment += tr.adjustment;
      table_last_tr.offset.payAmount += tr.offset.payAmount;
      table_last_tr.actualAmountResidual += tr.actualAmountResidual;

      payDetailsIndex++;
    });

    tableData.push(table_last_tr);
  }

  if (targetSourceList.elseBuy) {
    let cinemaOption = [];
    let clientOption = [];

    cinemaList.map(item => {
      cinemaOption.push(item.id, item.name);
    });

    clientList.map(item => {
      clientOption.push(item.id, item.name);
    });

    targetSourceList.elseBuy.map(item => {
      let tr = {
        cinemaId: item.cinemaId,
        clientId: item.clientId,
        dateInterval: item.dateInterval,
        needPayAmount: item.needPayAmount,
        payAmount: item.payAmount,
        payMoney: 0,
        adjustment: 0,
        offset: {
          payAmount: 0,
        },
        actualAmountResidual: item.actualAmountResidual,
        uuid: item.uuid,

        cinemaName: cinemaOption[cinemaOption.indexOf(item.cinemaId) + 1],
        clientName: clientOption[clientOption.indexOf(item.clientId) + 1],
        showName: item.showName,
        requestDeadDateText: obj.requestDeadDate ? moment(obj.requestDeadDate).format("YYYY-MM-DD") : "",
      };

      if (payDetails.length > 0) {
        tr = { ...tr, ...payDetails[payDetailsIndex] };
      }

      otherTableData.push(tr);
      otherTable_last_tr.needPayAmount += tr.needPayAmount;
      otherTable_last_tr.payAmount += tr.payAmount;
      otherTable_last_tr.payMoney += tr.payMoney;
      otherTable_last_tr.adjustment += tr.adjustment;
      otherTable_last_tr.offset.payAmount += tr.offset.payAmount;
      otherTable_last_tr.actualAmountResidual += tr.actualAmountResidual;

      payDetailsIndex++;
    });

    otherTableData.push(otherTable_last_tr);
  }

  return { tableData, otherTableData };
};

export const createPaymentForm = () => {
  return {
    accountPayableId: "",
    actualAmountResidual: 0,
    brandId: "",
    date: moment().startOf("day").valueOf(),
    name: "",
    type: "",
    typeDetail: "",
    payAmount: 0,
    payMoney: 0,
    payDetails: [],
    bankAccountId: "",
    payOffset: {
      id: "",
      offsetDetail: "",
      offsetDetailId: "",
    },
  };
};

export const createPaymentTypeOption = () => {
  const typeOption = [
    {
      label: locale("accountPayable.accountPayment"),
      value: "ACCOUNT",
      child: [
        // {
        //   label: locale("accountPayable.fromDepositDestination"),
        //   value: locale("accountPayable.fromDepositDestination"),
        // }
      ],
    },
    {
      label: locale("accountPayable.offset"),
      value: "OFFSET",
      child: [
      //   {
      //     label: locale("accountPayable.fromAccountReceivableStatement"),
      //     value: locale("accountPayable.fromAccountReceivableStatement"),
      //   },
      //   {
      //     label: locale("accountPayable.offsetPaymentStatement"),
      //     value: locale("accountPayable.offsetPaymentStatement"),
      //   }
      ],
    },
    {
      label: locale("accountPayable.cash"),
      value: "CASH",
      child: [
        {
          label: locale("accountPayable.autoCash"),
          value: locale("accountPayable.autoCash"),
        }
      ],
    }
  ];

  return typeOption;
};

export const formatPaymentListData = (originAlArr, bankAccountList) => {
  let newArr = [];
  let thead = [
    {
      label: locale("accountPayable.paymentDate"),
      prop: "date",
    },
    {
      label: locale("accountPayable.paymentName"),
      prop: "name",
    },
    {
      label: locale("accountPayable.paymentCategory") + 1,
      prop: "typeText",
    },
    {
      label: locale("accountPayable.paymentCategory") + 2,
      prop: "typeDetail",
    },
    {
      label: locale("accountPayable.payMoney"),
      prop: "payMoney",
    },
    {
      label: locale("accountPayable.threeTotal"),
      prop: "payAmount",
    },
    {
      label: locale("accountPayable.th.accountPayableBalance"),
      prop: "actualAmountResidual",
    }
  ];
  let typeOption = createPaymentTypeOption();

  originAlArr.map(item => {
    let obj = {
      id: item.id,
      date: moment(item.date).format("YYYY-MM-DD"),
      name: item.name,
      type: item.type,
      typeText: "",
      typeDetail: "",
      payMoney: item.payMoney.toLocaleString(),
      payAmount: item.payAmount.toLocaleString(),
      actualAmountResidual: item.actualAmountResidual.toLocaleString(),
    };

    for (let i = 0; i < typeOption.length; i++) {
      if (obj.type == typeOption[i].value) {
        obj.typeText = typeOption[i].label;
        break;
      }
    }

    if (item.type == "ACCOUNT") {
      for (let i = 0; i < bankAccountList.length; i++) {
        if (bankAccountList[i].id == item.typeDetail) {
          obj.typeDetail = bankAccountList[i].name;
          break;
        }
      }
    } else if (item.type == "OFFSET") {
      obj.typeDetail = item.payOffset.offsetDetail;
    } else {
      obj.typeDetail = locale("accountPayable.autoCash");
    }

    newArr.push(obj);
  });

  return {
    tableData: newArr,
    thead: thead,
  };
};

export const createTypeList = () => {
  return [
    {
      value: "TICKETING",
      label: locale("accountPayable.type.TICKETING"),
    },
    {
      value: "BUY",
      label: locale("accountPayable.type.BUY"),
    },
    {
      value: "ELSE_BUY",
      label: locale("accountPayable.type.ELSE_BUY"),
    },
    {
      value: "PROXY_BUY",
      label: locale("accountPayable.type.PROXY_BUY"),
    }
  ];
};

export const formatOneTimePaymentTableData = (originAlArr, typeList) => {
  let newArr = [];
  let typeArr = [];
  let lastTr = {
    paymentDueDateText: locale("accountPayable.trTotal"),
    needPayAmount: 0,
    payAmount: 0,
    actualAmountResidual: 0,
    adjustment: 0,
    offset: {
      payAmount: 0,
    },
    payMoney: 0,
  };

  for (let i = 0; i < typeList.length; i++) {
    typeArr.push(typeList[i].value);
    typeArr.push(typeList[i].label);
  }

  originAlArr.map(item => {
    if (item.actualAmountResidual != 0) {
      let obj = {
        id: item.id,
        type: item.type,
        name: item.name,
        requestDeadDate: item.requestDeadDate,
        paymentDueDate: item.payDate,
        needPayAmount: item.needPayAmount,
        payAmount: item.payAmount,
        actualAmountResidual: item.actualAmountResidual,
        adjustment: 0,
        offset: {
          payAmount: 0,
        },
        payMoney: 0,
        payDetails: [],

        typeText: "",
        requestDeadDateText: "",
        paymentDueDateText: "",
      };
      let typeIndex = typeArr.indexOf(item.type);

      obj.typeText = typeArr[typeIndex + 1];
      obj.requestDeadDateText = item.requestDeadDate ? moment(item.requestDeadDate).format("YYYY-MM-DD") : item.requestDeadDate;
      obj.paymentDueDateText = item.payDate ? moment(item.payDate).format("YYYY-MM-DD") : item.payDate;

      if (item.targetSourceList.source) {
        item.targetSourceList.source.map(secItem => {
          let payDetailItem = {};
          let keyName = returnPayableType(item.type);

          payDetailItem = {
            ...secItem[keyName],
            payMoney: 0,
            adjustment: 0,
            offset: {
              payAmount: 0,
            },
            incomeTotal: 0,
            actualNumberTotal: 0,
            sourceType: keyName,
            filmName: secItem.filmName || "",
            storeName: secItem.storeName || "",
            showName: "",
            requestDeadDate: "",
          };

          if (secItem[keyName].amountDetail) {
            if (keyName == "ticketing") {
              for (let amountDetailKeyName in secItem.ticketing.amountDetail) {
                if (amountDetailKeyName != 'total') {
                  payDetailItem.incomeTotal += secItem.ticketing.amountDetail[amountDetailKeyName].income;
                  payDetailItem.actualNumberTotal += secItem.ticketing.amountDetail[amountDetailKeyName].actualNumber;
                }
              }
            }
          }
          obj.payDetails.push(payDetailItem);
        });
      }

      if (item.targetSourceList.elseBuy) {
        item.targetSourceList.elseBuy.map(secItem => {
          obj.payDetails.push({
            ...secItem,
            payMoney: 0,
            adjustment: 0,
            offset: {
              payAmount: 0,
            },
            incomeTotal: 0,
            actualNumberTotal: 0,
            sourceType: "elseBuy",
            filmName: "",
            storeName: "",
            showName: secItem.showName,
            requestDeadDate: item.requestDeadDate,
          });
        });
      }

      lastTr.needPayAmount += item.needPayAmount;
      lastTr.payAmount += item.payAmount;
      lastTr.actualAmountResidual += item.actualAmountResidual;
      
      newArr.push(obj);
    }
  });

  newArr.push(lastTr);

  return newArr;
};

export const createOffsetInvoiceTableTr = () => {
  return {
    brandId: "",
    
    invoiceId: "",
    requestName: "",

    clientId: "",
    clientName: "",

    offsetDetailId: "",
    offsetDetail: "",
    
    requestDeadDate: 0,
    actualAmountResidual: "",
    payAmount: "",
    minusResidualAmount: "",
  }
};

export const createOffsetRevenueTableTr = () => {
  return {
    cinemaId: "",
    cinemaName: "",

    otherRevenueId: "",
    otherName: "",

    price: "-",
    inventory: "-",
    unit: "-",
    payAmount: 0,
    comment: "",
  }
};

export const createOffsetOtherTableTr = () => {
  return {
    plus: false,

    cinemaId: "",
    cinemaName: "",

    otherGoodsId: "",
    otherName: "",

    price: "-",
    inventory: "-",
    unit: "-",
    payAmount: 0,
    comment: "",
  }
};

export const getKeyNames = type => {
  let keyNames = [];

  switch (type) {
    case "COMMON":
      keyNames = [ "appreciation", "good", "revenue", "other", "payable" ];
      break;

    case "NATIONAL":
      keyNames = [ "national", "nationalSales", "other", "payable" ];
      break;

    case "PAYMENT":
      keyNames = [ "payment" ];
      break;

    default:
      break;
  }

  return keyNames;
}

export const convertDateToJPTime = value => {
  const dateStr = moment(value).format("YYYY-MM-DD");
  return momentTimezone.tz(dateStr, "Asia/Tokyo");
};
